export default "__VITE_ASSET__um$Nbc6T__"